import { useRef } from 'react';

const useFullscreenRestrictions = () => {
  const handlers = useRef<{
    keyHandler?: (e: KeyboardEvent) => void;
    contextMenuHandler?: (e: MouseEvent) => void;
    copyHandler?: (e: ClipboardEvent) => void;
  }>({});

  const enableFullscreenRestrictions = async () => {
    try {
      const element = document.documentElement;

      if (element.requestFullscreen) {
        await element.requestFullscreen();
      } else if ((element as any).webkitRequestFullscreen) {
        await (element as any).webkitRequestFullscreen();
      }

      const keyHandler = (e: KeyboardEvent) => {
        if (e.key === 'Escape' || e.key === 'F11') {
          e.preventDefault();
        }
      };

      const contextMenuHandler = (e: MouseEvent) => {
        e.preventDefault();
      };

      const copyHandler = (e: ClipboardEvent) => {
        e.preventDefault();
      };

      const header = document.querySelector('header');
      const footer = document.querySelector('footer');
      if (header && footer) {
        header.style.display = 'none';
        footer.style.display = 'none';
      }

      handlers.current = {
        keyHandler,
        contextMenuHandler,
        copyHandler
      };

      document.addEventListener('keydown', keyHandler);
      document.addEventListener('contextmenu', contextMenuHandler);
      document.addEventListener('copy', copyHandler);

      document.body.style.userSelect = 'none';
      document.body.style.webkitUserSelect = 'none';

    } catch (error) {
      console.error('Error enabling fullscreen:', error);
    }
  };

  const disableFullscreenRestrictions = () => {
    if (handlers.current.keyHandler) {
      document.removeEventListener('keydown', handlers.current.keyHandler);
    }
    if (handlers.current.contextMenuHandler) {
      document.removeEventListener('contextmenu', handlers.current.contextMenuHandler);
    }
    if (handlers.current.copyHandler) {
      document.removeEventListener('copy', handlers.current.copyHandler);
    }

    const header = document.querySelector('header');
    const footer = document.querySelector('footer');
    if (header && footer) {
      header.style.display = 'block';
      footer.style.display = 'block';
    }

    document.body.style.userSelect = '';
    document.body.style.webkitUserSelect = '';

    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if ((document as any).webkitExitFullscreen) {
      (document as any).webkitExitFullscreen();
    }
  };

  return { enableFullscreenRestrictions, disableFullscreenRestrictions };
};

export default useFullscreenRestrictions;